// CopyToClipboard/index.js
import CopyToClipboard from './CopyToClipboard';
export default CopyToClipboard;
